import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Scrollbar from 'src/components/Scrollbar';
import { SidebarContext } from 'src/contexts/SidebarContext';

import {
  Box,
  Drawer,
  alpha,
  styled,
  Divider,
  useTheme,
  lighten,
  darken,
  IconButton,
  Tooltip

} from '@mui/material';

import ChevronLeftTwoToneIcon from '@mui/icons-material/ChevronLeftTwoTone';
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone';

import SidebarMenu from './SidebarMenu';
import Logo from 'src/components/LogoSign';
import HeaderUserbox from '../Header/Userbox';
import HeaderButtons from '../Header/Buttons';

const SidebarWrapper = styled(Box)(
  ({ theme }) => `
        width: ${theme.sidebar.width};
        min-width: ${theme.sidebar.width};
        color: ${theme.colors.alpha.trueWhite[100]};
        position: relative;
        z-index: 7;
        height: 100%;
        padding-bottom: 80px;
        transition: transform 0.3s ease, width 0.3s ease;
`
);

function Sidebar() {
  const { sidebarToggle, toggleSidebar, sidebarCollapsed, toggleSidebarCollapse } =
    useContext(SidebarContext);
  const closeSidebar = () => toggleSidebar();
  const theme = useTheme();
  const { t } = useTranslation();
 // const navigate = useNavigate();


  return (
    <>
      <Tooltip
        arrow
        placement="right"
        title={sidebarCollapsed ? t('header.openMenu') : t('header.closeMenu')}
      >
        <IconButton
          onClick={toggleSidebarCollapse}
          sx={{
            display: { xs: 'none', lg: 'flex' },
            position: 'fixed',
            top: '50%',
            left: sidebarCollapsed ? 8 : theme.sidebar.width,
            transform: sidebarCollapsed
              ? 'translateY(-50%)'
              : 'translate(-50%, -50%)',
            zIndex: 8,
            width: 28,
            height: 28,
            transition: 'left 0.3s ease',
            bgcolor: theme.colors.primary.main,
            color: '#000000',
            boxShadow: theme.sidebar.boxShadow,
            '&:hover': {
              bgcolor: theme.colors.primary.dark,
              color: '#000000'
            }
          }}
          size="small"
        >
          {sidebarCollapsed ? (
            <ChevronRightTwoToneIcon fontSize="small" />
          ) : (
            <ChevronLeftTwoToneIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
      <SidebarWrapper
        sx={{
          display: {
            xs: 'none',
            lg: 'inline-block'
          },
          position: 'fixed',
          left: 0,
          top: 80,
          transform: sidebarCollapsed ? 'translateX(-100%)' : 'none',
          background:
            theme.palette.mode === 'dark'
              ? alpha(lighten(theme.header.background, 0.1), 0.25)
              : darken(theme.colors.alpha.black[100], 0.5),
          boxShadow:
            theme.palette.mode === 'dark' ? theme.sidebar.boxShadow : 'none'
        }}
      >
        <Scrollbar>
          {/* <Box mt={9}>
            { <Box
              mx={11}
              sx={{
                width: 50
              }}
            >
              <Logo />
            </Box> }
          </Box> */}
          <Divider
            sx={{
              mt: theme.spacing(3),
              mx: theme.spacing(2),
              background: theme.colors.alpha.trueWhite[10]
            }}
          />
          <SidebarMenu />
        </Scrollbar>
        <Divider
          sx={{
            background: theme.colors.alpha.trueWhite[10]
          }}
        />
       <Box display="flex" alignItems="center" justifyContent={"center"} className='p-2'>
        <HeaderUserbox />
        
      </Box>
      </SidebarWrapper>
      <Drawer
        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
        open={sidebarToggle}
        onClose={closeSidebar}
        variant="temporary"
        elevation={9}
        PaperProps={{
          sx: {
            width: { xs: '80vw', sm: theme.sidebar.width },
            maxWidth: theme.sidebar.width,
            boxShadow: theme.sidebar.boxShadow
          }
        }}
      >
        <SidebarWrapper
          sx={{
            width: '100%',
            minWidth: 'unset',
            background:
              theme.palette.mode === 'dark'
                ? theme.colors.alpha.white[100]
                : darken(theme.colors.alpha.black[100], 0.5)
          }}
        >
          <Scrollbar>
            {/* Logo `responsive` : l'ancien rendu (marge −80 px dans une boîte de 52 px)
                sortait l'image du tiroir et laissait un vide en haut du menu mobile. */}
            <Box mt={3} mx={2} display="flex" minWidth={0}>
              <Logo responsive />
            </Box>
            <Divider
              sx={{
                mt: theme.spacing(3),
                mx: theme.spacing(2),
                background: theme.colors.alpha.trueWhite[10]
              }}
            />
            <SidebarMenu />
          </Scrollbar>
          <Divider sx={{ background: theme.colors.alpha.trueWhite[10] }} />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            px={2}
            py={1}
          >
            <HeaderButtons />
            <HeaderUserbox />
          </Box>
        </SidebarWrapper>
      </Drawer>
    </>
  );
}

export default Sidebar;
